module.exports = __webpack_public_path__ + "img/FondoLetras.740694cc.png";